import { loadSprites } from '../engine/assetLoader';
import { Key } from '../engine/enums';
import { Renderable } from '../engine/renderable';
import Vector2d from '../engine/vector2d';
import Entity from '../entity';
import State from '../state';
import { createHiScoreEntry, getScores, readScores, writeScores, HiScoreEntry } from '../store';
import TextRenderer, { Color, FontSize } from '../text';
import TextInput, { InputState } from '../textInput';

import { RenderableScreen, Screen, ScreenManager } from './screenManager';

export default class GameOverScreen implements RenderableScreen {
  name = 'GameOverScreen';

  private readonly width: number;
  private readonly height: number;
  private readonly screenManager: ScreenManager;

  private gameObjects: Renderable<State>[] = [];
  private textRenderer: TextRenderer | undefined;
  private textInput1?: TextInput;
  private textInput2?: TextInput;

  private p1Score?: HiScoreEntry;
  private p2Score?: HiScoreEntry;
  private tempScores: HiScoreEntry[] | undefined;

  private onInput1Done = (name: String) => {
    if (this.p1Score) {
      this.p1Score.name = name;
      this.p1Score.timestamp = Date.now();
    }
  }

  private onInput2Done = (name: String) => {
    if (this.p2Score) {
      this.p2Score.name = name;
      this.p2Score.timestamp = Date.now();
    }
  }

  constructor(screenManager: ScreenManager) {
    this.screenManager = screenManager;
    this.width = screenManager.width;
    this.height = screenManager.height;
  }

  onPlayerInput(player: Entity, key: Key): void {
    const { textInput1, textInput2 } = this;

    if (textInput1 && textInput2) {
      if (player.name === 'player-0') {
        textInput1.move(key);
      }

      if (player.name === 'player-1') {
        textInput2.move(key);
      }


      if (
        textInput1.inputState !== InputState.Pending &&
        textInput2.inputState !== InputState.Pending
      ) {
        if (this.p1Score || this.p2Score) {
          writeScores(this.tempScores ?? []);
        }

        this.screenManager.setScreen(Screen.HighScore);
      }
    }
  }

  initScreen(state: State): void {

    const { players } = state;

    const [player1, player2] = players;

    this.p1Score = createHiScoreEntry('#p1', player1?.score ?? 0);
    this.p2Score = createHiScoreEntry('#p2', player2?.score ?? 0);
    this.tempScores = getScores([...readScores(), this.p1Score, this.p2Score]);

    state.reset();
    this.gameObjects = [];

    loadSprites([
      'font'
    ])
      .then(sprites => {
        this.textRenderer = new TextRenderer(sprites.find(s => s.name === 'font'));
        this.textInput1 = new TextInput(this.textRenderer, new Vector2d(3, 28), this.onInput1Done, this.p1Score && (this.tempScores ?? []).indexOf(this.p1Score) !== -1 ? InputState.Pending : InputState.Disabled);
        this.textInput2 = new TextInput(this.textRenderer, new Vector2d(40, 28), this.onInput2Done, this.p2Score && (this.tempScores ?? []).indexOf(this.p2Score) !== -1 ? InputState.Pending : InputState.Disabled);
        this.update(0, state);
      });
  }

  update(gameTime: number, state: State): void {
    if (gameTime % 2 === 0) {
      this.gameObjects.forEach(obj => obj.update(gameTime, state));
    }
  }

  render(_: State, gameTime: number, ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, this.width, this.height);

    this.textRenderer?.renderText(`Game over!`, FontSize.Large, Color.White, new Vector2d(25, 18), ctx);

    if (this.textInput1?.inputState !== InputState.Disabled) {
      this.textRenderer?.renderText(`P1 Enter your name`, FontSize.Normal, Color.Cyan, new Vector2d(3, 26), ctx);
      this.textInput1?.render(gameTime, ctx);
    }

    if (this.textInput2?.inputState !== InputState.Disabled) {
      this.textRenderer?.renderText(`P2 Enter your name`, FontSize.Normal, Color.Cyan, new Vector2d(40, 26), ctx);
      this.textInput2?.render(gameTime, ctx);
    }

    if (this.textInput1?.inputState === InputState.Disabled && this.textInput2?.inputState === InputState.Disabled) {
      this.textRenderer?.renderText(`Press any button`, FontSize.Normal, Color.Cyan, new Vector2d(24, 32), ctx);
    }

    ctx.save();
  }
}
